import { put, call } from 'redux-saga/effects';
import axios from '../../../utils/axios';
import { BASEURL } from '../../../BaseUrl/BaseUrl';
import {
  startFormLoading,
  stopFormLoading,
  hasError,
  getErrorMessage,
  getSuccessMessage,
  setResponse,
} from '../../slices/responseStatus';
import { isLogout } from '../../slices/login';
import { getnegativeStockData } from '../../slices/negativeStockSlice';

export function* negativeStockSaga() {
  try {
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/companies/negativeStock`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const negativeStock = response?.data?.data?.negative_stock;
    yield put(getnegativeStockData(negativeStock === undefined ? [] : negativeStock));
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
    if (error.error?.statusCode === 401) {
      yield put(isLogout(true));
    }
  }
}

export function* setNegativeStockSaga(state) {
  try {
    yield put(hasError(false));
    const { data } = state;
    const newData = {
      negative_stock: data,
    };
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.put(`${BASEURL}/companies/negativeStock`, newData, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    if (response.status === 200) {
      yield put(getSuccessMessage(response.data.meta.message));
      yield put(setResponse(response.status));
    }
    yield call(negativeStockSaga);
    yield put(stopFormLoading());
  } catch (error) {
    yield put(stopFormLoading());
    yield put(hasError(true));

    yield put(getErrorMessage(error.error.message));
  }
}
